import tinycolor from 'tinycolor2';
import { isDataView } from 'util/types';

export * from './color';
export * from './defaults';

export const convert6DigitHexTo8 = (color: string) => {
  var prefix = Math.round((100 / 100) * 255);
  var hex = (prefix + 0x10000).toString(16).substr(-2).toUpperCase();

  const newColor = hex + color.slice(1);

  return newColor;
};

export const hexToRGB = (hexCode: string, opacity = 1) => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  /* Backward compatibility for whole number based opacity values. */
  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }

  return `rgba(${r},${g},${b},${opacity})`;
};

export function darkenColor(hex: string, factor: number): string {
  // Convert hex to RGB
  let r: number = parseInt(hex.substring(1, 3), 16);
  let g: number = parseInt(hex.substring(3, 5), 16);
  let b: number = parseInt(hex.substring(5, 7), 16);

  // Darken the color by multiplying each component by the factor (0.9 in this case)
  r = Math.max(0, Math.floor(r * factor));
  g = Math.max(0, Math.floor(g * factor));
  b = Math.max(0, Math.floor(b * factor));

  // Convert back to hex
  const darkenedHex: string = `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  return darkenedHex;
}

export const getContrastBackgroundColor1 = (
  color: string,
  isDarkTheme: boolean
) =>
  tinycolor(color)
    .lighten(isDarkTheme ? 1 : 9)
    .toString();

// export function hexToRGB(hex: string, alpha: number) {
//     var r = parseInt(hex.slice(1, 3), 16),
//         g = parseInt(hex.slice(3, 5), 16),
//         b = parseInt(hex.slice(5, 7), 16);

//     if (alpha) {
//         return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
//     } else {
//         return "rgb(" + r + ", " + g + ", " + b + ")";
//     }
// }

// export function getContrastTextColor(hex: string): string {
//   // Convert hex to RGB
//   let r: number = parseInt(hex.substring(1, 3), 16);
//   let g: number = parseInt(hex.substring(3, 5), 16);
//   let b: number = parseInt(hex.substring(5, 7), 16);

//   // Calculate brightness using the formula: (r * 299 + g * 587 + b * 114) / 1000
//   const brightness: number = (r * 299 + g * 587 + b * 114) / 1000;

//   // Adjust the contrastFactor based on brightness
//   let contrastFactor: number;
//   if (brightness < 15) {
//     return '#ffffff'; //'#e3e3e3';
//   } else if (brightness > 128) {
//     // Light background, use a darker text color
//     contrastFactor = 0.5;
//   } else {
//     // Dark background, use a lighter text color
//     contrastFactor = 4;
//   }

//   // Calculate the contrasting foreground color
//   r = Math.max(0, Math.min(255, Math.floor(r * contrastFactor)));
//   g = Math.max(0, Math.min(255, Math.floor(g * contrastFactor)));
//   b = Math.max(0, Math.min(255, Math.floor(b * contrastFactor)));

//   // Convert back to hex
//   const contrastingHex: string = `#${r.toString(16).padStart(2, '0')}${g
//     .toString(16)
//     .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;

//   if (hex === contrastingHex) return readableColor(hex);
//   return contrastingHex;
// }

export const getBasicTextColor = (isDarkTheme: boolean) =>
  isDarkTheme ? '#ffffff' : '#000000';

export const getOppositeTextColor = (isDarkTheme: boolean) =>
  isDarkTheme ? '#000000' : '#ffffff';

export const getBasicBackgroundColor = (isDarkTheme: boolean) =>
  isDarkTheme ? '#121212' : '#ffffff';

export function addAlpha(color: string, opacity: number): string {
  // coerce values so ti is between 0 and 1.
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}
